import api from './api';

// Types

export interface AdminOverview {
  total_students: number;
  active_today: number;
  active_this_week: number;
  avg_accuracy_30d: number;
  total_questions: number;
}

export interface RetentionCohort {
  signup_week: string;
  cohort_size: number;
  retention: number[]; // week 0..8 percentages
}

export interface ActiveUsersDay {
  date: string;
  dau: number;
  wau: number;
  mau: number;
  stickiness: number;
}

export interface SessionMetricsWeek {
  week: string;
  avg_duration: number;
  avg_questions: number;
  sessions_per_user: number;
}

export interface LearningOutcomesData {
  mastery_per_week: { week: string; count: number }[];
  avg_time_to_mastery_days: number;
  gate_pass_rates: { week: string; total: number; passed: number; rate: number }[];
}

export interface AIUsageData {
  by_feature: { feature_type: string; usage_count: number }[];
  daily_trend: { date: string; count: number }[];
  ai_user_count: number;
  active_student_count: number;
  ai_adoption_pct: number;
}

// API calls

export const checkAdmin = async (): Promise<{ is_admin: boolean }> => {
  const response = await api.get('/api/admin/analytics/check');
  return response.data;
};

export const getAdminOverview = async (): Promise<AdminOverview> => {
  const response = await api.get('/api/admin/analytics/overview');
  return response.data;
};

export const getRetentionCohorts = async (): Promise<RetentionCohort[]> => {
  const response = await api.get('/api/admin/analytics/retention-cohorts');
  return response.data;
};

export const getActiveUsers = async (): Promise<ActiveUsersDay[]> => {
  const response = await api.get('/api/admin/analytics/active-users');
  return response.data;
};

export const getSessionMetrics = async (): Promise<SessionMetricsWeek[]> => {
  const response = await api.get('/api/admin/analytics/session-metrics');
  return response.data;
};

export const getLearningOutcomes = async (): Promise<LearningOutcomesData> => {
  const response = await api.get('/api/admin/analytics/learning-outcomes');
  return response.data;
};

export const getAIUsage = async (): Promise<AIUsageData> => {
  const response = await api.get('/api/admin/analytics/ai-usage');
  return response.data;
};
